// React import
import * as React from 'react';
// Standard layout imports
import { ISubActivityModel } from 'src/Entities/Activity/Activity';
import { format } from 'date-fns';
import mapMarker from 'src/images/map_marker.png';
interface IProps {
  subActivity: ISubActivityModel;
}
const SubActivitiesItem = ({ subActivity }: IProps) => {
  return (
    <div>
      <b className="has-text-black">{subActivity.name}</b>
      <div className="f5 fw5 has-text-black">
        {format(new Date(subActivity.startDate), 'dd.MM.yyyy')}{' '}
        {subActivity.startTime} -{' '}
        {format(new Date(subActivity.endDate), 'dd.MM.yyyy')}{' '}
        {subActivity.endTime}
        <br />
        <a
          target="_blank"
          className="text-inherit no-underline"
          href={'https://maps.google.com/?q=' + subActivity.location}
        >
          {subActivity.location}
          <img src={mapMarker} height="20px" className="align-middle ml-2" />
        </a>{' '}
        <br />
        Overnatning: {subActivity.isSleepOver ? 'Ja' : 'Nej'}
      </div>
      <div className="w-12 border-b-4 border-gray-body pb-4 mb-2" />
    </div>
  );
};

export default SubActivitiesItem;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Activityies/Activity/subActivityItem.tsx